module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0098.jpg?v=ef53fb0a";